<template>
    <div>
        <div>
            <form name="form_ipin" method="post"> 
                <input type="hidden" name="m" v-model="m" >
                <input type="hidden" name="enc_data" v-model="enc_data" >
                <input type="hidden" name="param_r1" v-model="param_r1" >
                <input type="hidden" name="param_r2" v-model="param_r2" >
                <input type="hidden" name="param_r3" v-model="param_r3" >
            </form>
        </div>
        <v-dialog/>
    </div>
</template> 
<script>
import { getIpinEncrypt } from '@/api/common'

export default {
    name: 'CallIpinAuthPop',
    data() {
        return {
            currentURL:'',
            reqInfo:'',
            returnURL:'',
            m:'pubmain',
            enc_data:'',
            param_r1:'',
            param_r2:'',
            param_r3:'',
        }
    },
    created() { 
          this.getInfo()
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : 아이핀 정보
         **/
        getInfo() {
            let serverName = location.hostname
            getIpinEncrypt({serverName: serverName}).then(res => {
                // alert('res.data.encData'+res.data.encData+', msg:'+res.data.rsltMsg)
                this.enc_data = res.data.encData
                this.$nextTick(()=>{
                    document.form_ipin.action = 'https://cert.vno.co.kr/ipin.cb'
                    document.form_ipin.submit();
                })
            })
        },
    },
}
</script>

<style scoped>

</style>